import styled, { css } from 'styled-components';

/** Holds the native input and the drawn circle on top of each other. */
export const CheckmarkRoot = styled.span<{ $size: number }>`
  position: relative;
  display: inline-flex;
  flex: none;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
`;

/**
 * The real checkbox, laid over the circle and invisible: taps, the keyboard,
 * screen readers and a wrapping label all reach a native input, so there is
 * no click or key handling to get wrong.
 */
export const CheckmarkNativeInput = styled.input`
  position: absolute;
  inset: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;

  :disabled {
    cursor: not-allowed;
  }
`;

/**
 * What is seen. Unchecked: an empty grey circle. Checked: the circle-check
 * icon Connect Brands uses for a picked menu item (CheckmarkCheckedIcon,
 * filling the whole box), so the border and background step aside.
 */
export const CheckmarkCircle = styled.span<{
  $checked: boolean;
  $disabled: boolean;
  $size: number;
}>`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  /* No border when checked: the icon is the whole circle, and a transparent
     border would shrink it by 4px. */
  border: ${({ $checked, theme }) =>
    $checked ? 'none' : '2px solid ' + theme.lightGray};
  background: ${({ $checked, theme }) =>
    $checked ? 'transparent' : theme.white};
  transition: ${({ theme }) => theme.transitions.ease200ms};

  svg {
    position: absolute;
    inset: 0;
    display: block;
    width: 100%;
    height: 100%;
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.45;
    `}

  ${CheckmarkNativeInput}:focus-visible + & {
    outline: 2px solid ${({ theme }) => theme.primary};
    outline-offset: 2px;
  }
`;
